import { timelineItems } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-950 py-16 md:py-24">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-8">
        <Reveal>
          <div className="text-center">
            <span className="text-xs font-bold tracking-[0.3em] text-accent-400 md:text-sm">TIMELINE</span>
            <h2 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-4xl">
              完整时间线 · 快讯流
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-background-300 md:text-base">
              从最初的一条深夜转发，到今天的持续追踪，按发生顺序逐条整理，帮你理清每一步的关键变化。
            </p>
          </div>
        </Reveal>

        <div className="relative mt-12 md:mt-16">
          <div className="absolute left-[11px] top-2 h-[calc(100%-2rem)] w-px bg-background-700 md:left-[15px]" />
          <ul className="flex flex-col gap-7 md:gap-9">
            {timelineItems.map((item, index) => (
              <li key={item.title} className="relative pl-9 md:pl-14">
                <Reveal delay={index * 40}>
                  <span
                    className={`absolute left-0 top-1.5 flex h-6 w-6 items-center justify-center rounded-full border-2 md:h-8 md:w-8 ${
                      item.live
                        ? 'border-primary-400 bg-primary-500'
                        : 'border-background-600 bg-background-900'
                    }`}
                  >
                    {item.live ? (
                      <span className="relative flex h-2 w-2 items-center justify-center">
                        <span className="absolute h-2 w-2 rounded-full bg-background-50 animate-pulse-dot" />
                        <span className="relative h-2 w-2 rounded-full bg-background-50" />
                      </span>
                    ) : (
                      <span className="h-2 w-2 rounded-full bg-background-500" />
                    )}
                  </span>

                  <div
                    className={`rounded-lg border p-5 transition-colors md:p-6 ${
                      item.live
                        ? 'border-primary-700/70 bg-primary-950/40'
                        : 'border-background-800 bg-background-900/60'
                    }`}
                  >
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="text-xs font-semibold tracking-wide text-accent-400 md:text-sm">
                        {item.time}
                      </span>
                      <span
                        className={`rounded-full px-2.5 py-0.5 text-[11px] font-semibold ${
                          item.live
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-background-800 text-background-200'
                        }`}
                      >
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="mt-3 font-heading text-base font-bold text-background-50 md:text-lg">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-background-300">{item.desc}</p>
                  </div>
                </Reveal>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}